<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/cashmanage/select"
      :model="formModel"
      @openAddDialog="changeInfo()"
      :submitService="submitService"
      addShowPower="/cashmanage/add"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="withdrawFee"
        label="提现费率(%)"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableNumberYuan"
      >
      </el-table-column>
      <el-table-column
        prop="withdrawRate"
        label="元/笔"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.withdrawRate * 100) / 10000) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="withdrawMin"
        label="提现最小值(元)"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.withdrawMin * 100) / 10000) }}</p>
        </template>
      </el-table-column>
        <el-table-column
        prop="withdrawMax"
        label="提现最大值(元)"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands((scope.row.withdrawMax * 100) / 10000) }}</p>
        </template>
      </el-table-column>

      <el-table-column
        prop="acctType"
        label="账户类型"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableacctType"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.status == 1 ? "启用" : "禁用" }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="160"
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="160"
        v-if="
          hasPerm('/cashmanage/edit') ||
          hasPerm('/cashmanage/delete') ||
          hasPerm('/cashmanage/udpStatus')
        "
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="changeInfo(scope.row.id)"
            v-if="hasPerm('/cashmanage/edit')"
            >修改</el-button
          >
          <!-- <el-button
            type="text"
            @click="DeleteInfo(scope.row.id)"
            class="button-color"
            v-if="hasPerm('/cashmanage/delete')"
            >删除</el-button
          > -->
          <el-button
            type="text"
            @click="Disabled(scope.row.id, scope.row.status)"
            class="button-color"
            v-if="hasPerm('/cashmanage/udpStatus')"
          >
            {{ scope.row.status == 1 ? "禁用" : "启用" }}
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      :dialogService="dialogService"
      :submitData="dialogData"
      :rules="dialogRules"
      @success="dialogSuccess"
      @close="dialogClose"
      @opend="dialogOpen"
      class="note"
      dialogWidth="640px"
      labelWidth="100px"
    >
      <el-form-item label="提现最小值" prop="withdrawMin">
        <el-input-number
          :controls="false"
          placeholder="请输入"
          v-model="dialogModel.withdrawMin"
          controls-position="right"
          :precision="2"
          :step="0.1"
          @change="handleChange"
          :min="0"
          style="width: 180px"
        ></el-input-number>
      </el-form-item>
        <el-form-item label="提现最大值" prop="withdrawMax">
        <el-input-number
          :controls="false"
          placeholder="请输入"
          v-model="dialogModel.withdrawMax"
          controls-position="right"
          :precision="2"
          :step="0.1"
          @change="handleChange"
          :min="0"
          style="width: 180px"
        ></el-input-number>
      </el-form-item>
      <div class="flex-row vertical-center">
        <div
          class="flex-row vertical-center flow-justify"
          style="margin-right: 20px"
        >
          <el-form-item label="提现费率" prop="withdrawFee">
            <el-input-number
              :controls="false"
              v-model="dialogModel.withdrawFee"
              controls-position="right"
              :precision="2"
              :step="0.1"
              @change="handleChange"
              :min="0"
              style="width: 180px"
            ></el-input-number>
            <span>%</span>
          </el-form-item>
        </div>
        <div class="flex-row vertical-center flow-justify">
          <el-form-item prop="withdrawRate">
            <div class="flex-row vertical-center">
              <div class="flex-row vertical-center flow-justify">
                <el-input-number
                  :controls="false"
                  placeholder="请输入"
                  v-model="dialogModel.withdrawRate"
                  controls-position="right"
                  :precision="2"
                  :step="0.1"
                  @change="handleChange"
                  :min="0"
                  style="width: 180px"
                ></el-input-number>
                <p class="unit">元/笔</p>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>

      <el-form-item label="描述" prop="remark">
        <el-input
          maxlength="80"
          show-word-limit
          v-model="dialogModel.remark"
          type="textarea"
          resize="none"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import OrganCashService from "service/OrganCashService";
import LYFAcctTypes from "service/constant/LYFAcctTypes";

import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import SelectOrgans from "components/business/SelectOrgans";

export default {
  name: "cashmanage",
  data() {
    return {
      formModel: {},
      submitService: OrganCashService.list,
      page: {},
      params: {},
      tableData: [],
      formDialogTitle: "",
      dialogModel: {
        withdrawFee: "0",
          withdrawMax: "0",
          withdrawMin: "0",
        withdrawRate: "0",
        remark: "",
      },
      dialogRules: {
        withdrawFee: [
          {
            required: true,
            message: "请输入计费标准",
          },
        ],
          withdrawMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
          withdrawMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        withdrawRate: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      cashId: "",
      checkFlag: false,
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectOrgans,
  },
  computed: {
    isExist() {
      return this.checkFlag;
    },
    submitData() {
      this.params = {
        userId: this.userId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },

    dialogService() {
      if (this.cashId) {
        return OrganCashService.update;
      } else {
        return OrganCashService.add;
      }
    },
    dialogData() {
      const params = {
        userId: this.userId,
        withdrawFee: this.dialogModel.withdrawFee,
          withdrawMin: this.dialogModel.withdrawMin * 100,
          withdrawMax: this.dialogModel.withdrawMax * 100,
        withdrawRate: this.dialogModel.withdrawRate * 100,
        remark: this.dialogModel.remark,
      };
      if (this.cashId) {
        params.id = this.cashId;
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  methods: {
    changeInfo(id) {
      if (id) {
        this.formDialogTitle = "修改提现";
      } else {
        this.formDialogTitle = "添加提现";
      }
      this.cashId = id;
      this.$refs.formDialog.open();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        OrganCashService.list,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getDetail() {
      const params = {
        id: this.cashId,
      };

      this.doLoad(
        OrganCashService.detail,
        params,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogModel = result;
            // this.dialogModel.withdrawFee =
            //   (this.dialogModel.withdrawFee * 100) / 10000;
            this.dialogModel.withdrawMax =
              (this.dialogModel.withdrawMax * 100) / 10000;
            this.dialogModel.withdrawMin =
              (this.dialogModel.withdrawMin * 100) / 10000;
            this.dialogModel.withdrawRate =
              (this.dialogModel.withdrawRate * 100) / 10000;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    dialogSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.showSuccess(result.optMsg);
        this.$refs.formDialog.closeDialog();
        this.getList();
      });
    },
    dialogClose() {
      this.dialogModel = {
        withdrawFee: "0",
          withdrawMin: "0",
          withdrawMax: "0",
        withdrawRate: "0",
        remark: "",
      };
    },
    dialogOpen() {
      if (this.cashId) {
        this.getDetail();
      }
    },
    doDisabled(id) {
      const disabledParams = {
        id: id,
        status: this.status,
        userId: this.userId,
      };
      this.doLoad(
        OrganCashService.dpStatus,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    Disabled(id, type) {
      if (type == 0) {
        this.status = 1;
        this.showMsg = "确定启用此机构？";
      } else if (type == 1) {
        this.status = 0;
        this.showMsg = "确定禁用此机构？";
      }
      this.showConfirm(this.showMsg)
        .then(() => {
          this.doDisabled(id);
        })
        .catch(() => {});
    },
    handleChange() {},
    doDeleteInfo(id) {
      const disabledParams = {
        id: id,
      };
      this.doLoad(
        OrganCashService.delInfo,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    DeleteInfo(id) {
      this.showMsg = "确定删除此实名通道？";
      this.showConfirm(this.showMsg)
        .then(() => {
          this.doDeleteInfo(id);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.unit {
  width: 50px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/CashManage.vue